import { defineMessages } from 'utils/intl';

export default defineMessages({
  similar: 'Podobne artykuły',
  recommended: 'Polecane produkty',
  updated: 'Zaktualizowany',
});
